import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavStateService {
    private currentTitleSubject = new BehaviorSubject<string>('Agrify');
    currentTitle$ = this.currentTitleSubject.asObservable();

    private showBackButtonSubject = new BehaviorSubject<boolean>(false);
    showBackButton$ = this.showBackButtonSubject.asObservable();

    setCurrentTitle(title: string) {
        Promise.resolve().then(() => {
            this.currentTitleSubject.next(title);
        });
    }

    setShowBackButton(show: boolean) {
        Promise.resolve().then(() => {
            this.showBackButtonSubject.next(show);
        });
    }
}
